<template>
    <HamletStaticTable
        :columns="columns"
        :items="localValue"
        :striped="false"
        :bordered="true"
        empty-mode="message"
        card-class="pt-0 mt-0"
    >
        <template #header-label>
            {{ $t('Component(ResearchReviewProcess):product-facts') }}
        </template>

        <template #header-controls>
            <CommonButton
                variant="primary"
                size="sm"
                @click="addRow"
            >
                {{ $t('Component(Button):add') }}
            </CommonButton>
        </template>

        <template #cell-code="{ item }">
            <b-form-input v-model="item.code" />
        </template>

        <template #cell-name="{ item }">
            <b-form-input v-model="item.name" />
        </template>

        <template #cell-scipNumber="{ item }">
            <b-form-input v-model="item.scipNumber" />
        </template>

        <template #cell-actions="{ item }">
            <CommonButton
                variant="danger"
                size="sm"
                class="btn-icon"
                @click="removeRow(item)"
            >
                <feather-icon
                    icon="MinusIcon"
                    size="14"
                />
            </CommonButton>
        </template>
    </HamletStaticTable>
</template>

<script>
import { BFormInput } from 'bootstrap-vue'
import { HamletStaticTable, Button as CommonButton } from '@core/components/common'

function clone(value) {
    return JSON.parse(JSON.stringify(value || []))
}

function isEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b)
}

function normalize(items) {
    return Array.isArray(items)
        ? clone(items).map(item => {
            const row = item && typeof item === 'object' ? item : {}

            return {
                extractedProductId: row.extractedProductId !== undefined ? row.extractedProductId : null,
                name: row.name || '',
                code: row.code || '',
                scipNumber: row.scipNumber || '',
            }
        })
        : []
}

function emptyRow() {
    return {
        extractedProductId: null,
        name: '',
        code: '',
        scipNumber: '',
    }
}

export default {
    name: 'ProductsSection',
    components: {
        BFormInput,
        HamletStaticTable,
        CommonButton,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            localValue: normalize(this.value),
            columns: [
                { key: 'code', label: this.$t('Component(Grid):column-id') },
                { key: 'name', label: this.$t('Component(Grid):column-title') },
                { key: 'scipNumber', label: this.$t('Component(Label):scip-number') },
                {
                    key: 'actions', label: '', thClass: 'text-right', tdClass: 'text-right',
                },
            ],
        }
    },
    watch: {
        value: {
            deep: true,
            handler(newValue) {
                const normalized = normalize(newValue)
                if (isEqual(normalized, this.localValue)) {
                    return
                }

                this.localValue = normalized
            },
        },
        localValue: {
            deep: true,
            handler(newValue) {
                const emitted = clone(newValue)
                const current = normalize(this.value)

                if (isEqual(emitted, current)) {
                    return
                }

                this.$emit('input', emitted)
            },
        },
    },
    methods: {
        addRow() {
            this.localValue.push(emptyRow())
        },
        removeRow(item) {
            const index = this.localValue.indexOf(item)
            if (index === -1) {
                return
            }

            this.localValue.splice(index, 1)
        },
    },
}
</script>
